import React, { useState, Dispatch, SetStateAction } from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { ConfirmationDialog } from '../../legacy-design-system/modal'
import { useContrastMutation } from '../../hooks/use-contrast-mutation'
import { deleteSourceName } from './api/requests/delete-source-name'

export function DeleteSourceNameConfirmation({
  organizationID,
  sourceName,
  onSuccess,
  children
}: {
  readonly organizationID: string
  readonly sourceName: {
    readonly id: string
    readonly name: string
  }
  readonly onSuccess: () => void
  readonly children: (props: {
    readonly setIsOpen: Dispatch<SetStateAction<boolean>>
  }) => React.ReactNode
}) {
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const { mutate: deleteSource } = useContrastMutation(deleteSourceName, {
    onSuccess
  })

  return (
    <>
      {children({ setIsOpen })}
      <ConfirmationDialog
        size="small"
        isOpen={isOpen}
        onCancel={() => setIsOpen(false)}
        onConfirm={() => {
          setIsOpen(false)
          deleteSource({
            organizationUuid: organizationID,
            sourceNameId: sourceName.id
          })
        }}
        renderConfirmMessage={() => (
          <Text font="body" color="white">
            {intl.formatMessage({ id: 'action_delete' })}
          </Text>
        )}
        renderCancelMessage={() => (
          <Text font="body" color="neutral100">
            {intl.formatMessage({ id: 'action_cancel' })}
          </Text>
        )}
        renderTitle={() =>
          intl.formatMessage({
            id: 'title_ipsManagement_ipSourceNames_deleteConfirmationTitle'
          })
        }
        renderBody={() => (
          <div
            className={css`
              margin-bottom: 16px;
            `}
          >
            <Text font="body">
              {intl.formatMessage(
                { id: 'title_ipsManagement_ipSourceNames_deleteDescription' },
                { name: <strong>{sourceName.name}</strong> }
              )}
            </Text>
          </div>
        )}
      />
    </>
  )
}
